import { createSlice } from '@reduxjs/toolkit';

function generatePlaybackUrl(recordingUrl, recordingPath) {
    if (!recordingUrl || !recordingPath) {
        return '';
    }
    // Start time = current time - 5 minutes (300000ms)
    const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
    const startTime = encodeURIComponent(fiveMinutesAgo.toISOString());
    return `${recordingUrl}?duration=300&path=${recordingPath}&start=${startTime}`;
}

const initialState = {
    isOpen: false,
    url: null,
    isLoading: false,
    error: null,
    activeCamId: null,
    cameraName: null,
    isVideoPlaying: false,
    transactionId: null,
};

const playbackSlice = createSlice({
    name: 'playback',
    initialState,
    reducers: {
        openPlayback(state, { payload }) {
            const recordingUrl = payload?.recordingUrl || '';
            const recordingPath = payload?.recordingPath || '';
            const generatedUrl = generatePlaybackUrl(recordingUrl, recordingPath);

            state.isOpen = true;
            state.isLoading = false;
            state.error = generatedUrl ? null : 'Playback is not available for this camera.';
            state.url = generatedUrl || null;
            state.activeCamId = payload?.camId || null;
            state.cameraName = payload?.cameraName || null;
            state.transactionId = payload?.transactionId || null;
        },
        closePlayback(state) {
            state.isOpen = false;
            state.url = null;
            state.isLoading = false;
            state.error = null;
            state.activeCamId = null;
            state.cameraName = null;
            state.isVideoPlaying = false;
            state.transactionId = null;
        },
        setVideoPlaying(state, { payload }) {
            state.isVideoPlaying = payload;
        },
    },
});

export const playbackActions = playbackSlice.actions;
export const playbackReducer = playbackSlice.reducer;
